export const ASSIGNMENTS_API_URL = `/api/microplanning/assignments/`;
